:host {
  display: block;
}

@media screen and (min-width: 360px) {
  .image-capture-container__grid {
    grid-template-columns: repeat(2, minmax(112px, 240px));
    column-gap: 16px;
  }
}

@media screen and (min-width: 768px) {
  .image-capture-container__grid {
    grid-template-columns: repeat(6, minmax(96px, 240px));
    column-gap: 10px;
  }
}
